import { Navigate, Route, BrowserRouter as Router, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { AuthProvider } from "./components/00-MAIN/00-CONTEXT/AuthContext";
import ProtectedRoute from "./components/00-MAIN/01-SECURITY/ProtectedRoute";
import Layout from "./components/00-MAIN/02-LAYOUT/Layout";
import LoginPage from "./components/00-MAIN/04-CONNEXION/LOGIN-PAGE/LoginPage";
import SignupPage from "./components/00-MAIN/04-CONNEXION/SIGNUP-PAGE/SignupPage";
import StartPage from "./components/00-MAIN/04-CONNEXION/START-PAGE/StartPage";
import HomeApp from "./components/01-HOME/01-HOME-APP/HomeApp";
import AccountPage from "./components/01-HOME/03-TOP-BAR/ACCOUNT-PAGE/AccountPage";
import SubscriptionPage from "./components/01-HOME/03-TOP-BAR/ACCOUNT-PAGE/PLAN-SOUSCRIPTION/PlanSubscription";
import EspacePersonnelApp from "./components/02-ESPACE-PERSONNEL/00-HOME/EspacePersonnelApp";


const API_BASE_URL = process.env.REACT_APP_USER_BACKEND_API_URL;
if (!API_BASE_URL) {
  console.error("La variable d'environnement pour l'URL de l'API backend n'est pas définie !");
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Public */}
          <Route path="/" element={<Navigate to="/login" replace />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/signup" element={<SignupPage />} />
          <Route path="/start" element={<StartPage />} />
          <Route path="/subscription" element={<SubscriptionPage />} />

          {/* Application */}
          <Route element={<Layout />}>
            <Route path="/home" element={<ProtectedRoute><HomeApp /></ProtectedRoute>} />
            <Route path="/dashboard" element={<Navigate to="/home" replace />} />
            <Route path="/account" element={<ProtectedRoute><AccountPage /></ProtectedRoute>} />

            {/* Espace Personnel */}
            <Route path="/espace-personnel" element={<ProtectedRoute><EspacePersonnelApp /></ProtectedRoute>} />


          </Route>
        </Routes>
        <ToastContainer position="bottom-right" autoClose={3000} />
      </Router>
    </AuthProvider>
  );
}

export default App;